// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure mat-header-cell is targeted properly */
.mat-mdc-header-cell{
  background-color: #0b2d71 !important; /* Dark blue background */
  color: white; /* White text for contrast */
  font-weight: bold; /* Bold text for headers */
}
label {
  margin-bottom: 5px; /* Adds space between label and input */
  margin-top: 5px;
  margin-left: 15px;
}
  
/* Table styling */
mat-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
 
.mat-header-cell, .mat-cell {
  border: 1px solid white;
  text-align: center;
  padding: 8px;
}
 
.mat-row {
  transition: background-color 0.3s ease;
}
 
/* .mat-row:hover {
  background-color: #f7f7f7; 
} */
 
.mat-paginator {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
 
/* Form and Button Styling */
.button-container {
  display: flex;
  justify-content: center;
  /* gap: 20px;
  margin-top: 20px; */
}
 
form label {
  margin-right: 10px;
  margin-left: 70px;
  /* margin-top: 30px; */
}
 
form button {
  margin-left: 10px;
  margin-right: 10px;
  justify-self: center;
}
 
/* .form-inline{
  margin-top: 20px;
} */
form select#orderby {
  width: 300px;
}
 
form button {
  display: flex;
  justify-content: center;
}
 
/* form button:hover {
  background-color: #09326f;
} */
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Adjust as needed */
}

.center-content {
  margin: auto;
}
.title h3{
    background-color: #6699cc;
    color: #ffffff;
    padding: 10px;
    text-align: left;
  }

.error-message {
  color: red;
  font-weight: bold;
  margin-top: 10px;
}

.hidden-paginator {
  display: none;
}
  #criteria{
    width: 200px; 
    height: 35px;
  }
  .form-inline {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  
  .form-inline label {
    margin-right: 10px;
  }
  
  .form-inline input {
    margin-right: 10px;
  }
  
  .form-inline label:last-of-type {
    margin-right: 100px;
  }
  
  .form-inline button {
    margin-left: 10px;
  }
  .form-inline label[for="entervalue"] {
    margin-right: 26px;
  }
  
  .form-inline input#entervalue {
    margin-left: 10px;
  }
  
  .dv-app-lookup {
    margin-top: 40px;
}

.dv-app-lookup label {
    float: left;
    margin-right: 10px;
    line-height: 2.5; /* Adjust this value to vertically align with the input */
}

.dv-app-lookup .input-container {
    overflow: hidden; /* Clear the float */
}

.dv-app-lookup input {
    float: left;
    width: auto; /* Adjust width as needed */
}

.bordered-container {
  border: 1px solid #d3d3d3; 
  padding: 20px;
  max-width: 100%;
  margin: 3% 0%;
  border-radius: 1px;
  padding-bottom: 1%;
}
/* .app-lookup {
  display: block;
  width: 100%;
} */
table a {
  color: blue;
  cursor: pointer;
  text-decoration: none;
}

table a:hover {
  text-decoration: underline;
}
.shift-left{
  margin-right: -45%;
}
.large-search{
  width:250%;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/delegationofauthority/getemployees/getemployees.component.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,oCAAoC,EAAE,yBAAyB;EAC/D,YAAY,EAAE,4BAA4B;EAC1C,iBAAiB,EAAE,0BAA0B;AAC/C;AACA;EACE,kBAAkB,EAAE,uCAAuC;EAC3D,eAAe;EACf,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;GAEG;;AAEH;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB;qBACmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;GAEG;AACH;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;GAEG;AACH;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,qBAAqB;AACtC;;AAEA;EACE,YAAY;AACd;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;AAEF;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB,EAAE,yDAAyD;AAC/E;;AAEA;IACI,gBAAgB,EAAE,oBAAoB;AAC1C;;AAEA;IACI,WAAW;IACX,WAAW,EAAE,2BAA2B;AAC5C;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;GAGG;AACH;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ","sourcesContent":["/* Ensure mat-header-cell is targeted properly */\n.mat-mdc-header-cell{\n  background-color: #0b2d71 !important; /* Dark blue background */\n  color: white; /* White text for contrast */\n  font-weight: bold; /* Bold text for headers */\n}\nlabel {\n  margin-bottom: 5px; /* Adds space between label and input */\n  margin-top: 5px;\n  margin-left: 15px;\n}\n  \n/* Table styling */\nmat-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n \n.mat-header-cell, .mat-cell {\n  border: 1px solid white;\n  text-align: center;\n  padding: 8px;\n}\n \n.mat-row {\n  transition: background-color 0.3s ease;\n}\n \n/* .mat-row:hover {\n  background-color: #f7f7f7; \n} */\n \n.mat-paginator {\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-end;\n}\n \n/* Form and Button Styling */\n.button-container {\n  display: flex;\n  justify-content: center;\n  /* gap: 20px;\n  margin-top: 20px; */\n}\n \nform label {\n  margin-right: 10px;\n  margin-left: 70px;\n  /* margin-top: 30px; */\n}\n \nform button {\n  margin-left: 10px;\n  margin-right: 10px;\n  justify-self: center;\n}\n \n/* .form-inline{\n  margin-top: 20px;\n} */\nform select#orderby {\n  width: 300px;\n}\n \nform button {\n  display: flex;\n  justify-content: center;\n}\n \n/* form button:hover {\n  background-color: #09326f;\n} */\n.spinner-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh; /* Adjust as needed */\n}\n\n.center-content {\n  margin: auto;\n}\n.title h3{\n    background-color: #6699cc;\n    color: #ffffff;\n    padding: 10px;\n    text-align: left;\n  }\n\n.error-message {\n  color: red;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n.hidden-paginator {\n  display: none;\n}\n  #criteria{\n    width: 200px; \n    height: 35px;\n  }\n  .form-inline {\n    display: flex;\n    align-items: center;\n    margin-top: 20px;\n  }\n  \n  .form-inline label {\n    margin-right: 10px;\n  }\n  \n  .form-inline input {\n    margin-right: 10px;\n  }\n  \n  .form-inline label:last-of-type {\n    margin-right: 100px;\n  }\n  \n  .form-inline button {\n    margin-left: 10px;\n  }\n  .form-inline label[for=\"entervalue\"] {\n    margin-right: 26px;\n  }\n  \n  .form-inline input#entervalue {\n    margin-left: 10px;\n  }\n  \n  .dv-app-lookup {\n    margin-top: 40px;\n}\n\n.dv-app-lookup label {\n    float: left;\n    margin-right: 10px;\n    line-height: 2.5; /* Adjust this value to vertically align with the input */\n}\n\n.dv-app-lookup .input-container {\n    overflow: hidden; /* Clear the float */\n}\n\n.dv-app-lookup input {\n    float: left;\n    width: auto; /* Adjust width as needed */\n}\n\n.bordered-container {\n  border: 1px solid #d3d3d3; \n  padding: 20px;\n  max-width: 100%;\n  margin: 3% 0%;\n  border-radius: 1px;\n  padding-bottom: 1%;\n}\n/* .app-lookup {\n  display: block;\n  width: 100%;\n} */\ntable a {\n  color: blue;\n  cursor: pointer;\n  text-decoration: none;\n}\n\ntable a:hover {\n  text-decoration: underline;\n}\n.shift-left{\n  margin-right: -45%;\n}\n.large-search{\n  width:250%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
